import {useCallback, useMemo, useState} from "react";
import {getStoredRowColoring} from "./storage";

const useDataTableColoring = (props = {}) => {
    const { dataTableId } = props;
    
    const [rowColoring, setRowColoringState] = useState(() => 
        getStoredRowColoring(dataTableId, "alternate")
    );

    const setRowColoring = useCallback((value) => {
        setRowColoringState(value);
    }, []);

    return {
        rowColoring,
        setRowColoring,
    }
}

export default useDataTableColoring;
